import React from 'react';
import FirstSuccessDialog from '@/shadcn/components/FirstSuccessDialog.tsx';

const FirstSuccessModal = (props) => {
    let headline = '',
        subhead = '',
        primaryLabel = '',
        primaryData = '',
        secondaryLabel = '',
        secondaryData = '';

    if (props.context === "firstpost") {
        headline = "Success!";
        subhead = "You’ve created your first post. We’ll publish it shortly.";
        primaryLabel = "Create new post";
        primaryData = "newpost";
        secondaryLabel = "Go to calendar";
        secondaryData = "calendar";
    } else if (props.context === "newroute") {
        headline = "Your automation is live.";
        subhead = "We’re processing your input and we’ll start posting soon.";
        primaryLabel = "Create new automation";
        primaryData = "newautomation";
        secondaryLabel = "Go to automations";
        secondaryData = "automationlist";
    }

    const goTo = (which) => {
        let destination = '';

        switch (which) {
            case "newpost":
                destination = "/content/post";
                break;

            case "calendar":
                let socialID = props.socials.list[0].id;
                destination = `/queue/calendar/${socialID}`;
                break;

            case "newautomation":
                destination = "/share/automate/new/inputs";
                break;

            case "automationlist":
                destination = "/share/automate";
                break;

            default:
                break;
        }

        if (destination) {
            props.closeAllModals();
            props.router.navigate(destination);
        }
    };

    return (
        <FirstSuccessDialog
            headline={headline}
            subhead={subhead}
            primaryLabel={primaryLabel}
            secondaryLabel={secondaryLabel}
            onPrimary={() => {
                goTo(primaryData);
            }}
            onSecondary={() => {
                goTo(secondaryData);
            }}
            onClose={() => {
                props.closeAllModals();
            }}/>
    );
};

FirstSuccessModal.displayName = "FirstSuccessModal";

export default FirstSuccessModal;
